import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Initialize sidebar state
    this.sidebar = document.getElementById('sidebar')
    this.mainContent = document.getElementById('main-content')
    this.overlay = this.overlayTarget
  }

  toggleSidebar() {
    if (window.innerWidth < 992) {
      // Mobile view
      this.sidebar.classList.toggle('show')
      this.overlay.classList.toggle('show')
      
      // Prevent body scroll when sidebar is open
      if (this.sidebar.classList.contains('show')) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  }

  closeSidebar() {
    if (window.innerWidth < 992) {
      this.sidebar.classList.remove('show')
      this.overlay.classList.remove('show')
      document.body.style.overflow = 'auto'
    }
  }

  // Close sidebar when window is resized to desktop view
  handleResize() {
    if (window.innerWidth >= 992) {
      this.sidebar.classList.remove('show')
      this.overlay.classList.remove('show')
      document.body.style.overflow = 'auto'
    }
  }

  // Add resize listener when controller connects
  initialize() {
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }

  // Remove resize listener when controller disconnects
  disconnect() {
    window.removeEventListener('resize', this.handleResize)
    document.body.style.overflow = 'auto'
  }
}
